import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div``

export const List = styled.div`
  ${tw`grid gap-1`};
  grid-template-columns: repeat(${({ $columns }) => $columns}, minmax(0, 1fr));
`

export const TruncateButton = styled.button`
  color: var(--color-blue-grey);

  &:hover {
    color: var(--color-gold);
  }
`
